import { Toggle } from '@warp-ds/react/components/toggle';
import type { Filters } from '@/domain';

export type CheckboxOption = { label: string; value: string };

export type CheckboxFilterProps = {
    filterType: string;
    filterData?: string[] | CheckboxOption[];
    filterValues?: string | string[];
    onFilterChanged: (filters: Filters) => void;
    legend: string;
};

export const CheckboxFilter = ({ filterData = [], filterValues, filterType, onFilterChanged, legend }: CheckboxFilterProps) => {
    const normalizedValues = (() => {
        if (!filterValues) return [];
        return Array.isArray(filterValues) ? filterValues : [filterValues];
    })();

    const handleChange = (checked: boolean, value: string): void => {
        const checkedFilters = normalizedValues.filter((filterItem) => filterItem !== value);
        if (checked) {
            checkedFilters.push(value);
        }
        const filterObject: Record<string, string[]> = {};
        filterObject[filterType] = checkedFilters;
        onFilterChanged(filterObject);
    };

    const options = filterData.map((item) => (typeof item === 'string' ? { label: item, value: item } : item));

    return (
        <fieldset>
            <legend className="sr-only">{legend}</legend>
            {options.map(({ label, value }) => (
                <Toggle
                    key={value}
                    type="checkbox"
                    label={label}
                    checked={normalizedValues.includes(value)}
                    onChange={(checked: boolean) => handleChange(checked, value)}
                />
            ))}
        </fieldset>
    );
};
